import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    id: "tarifrechner",
    class: _normalizeClass({ gevspinner__aktiv: _ctx.zeigeSpinner })
  }, [
    _createVNode(_component_router_view),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "gevspinner" }, [
      _createElementVNode("div", null, [
        _createElementVNode("svg", {
          version: "1.0",
          xmlns: "http://www.w3.org/2000/svg",
          width: "933.333",
          height: "933.333",
          viewBox: "0 0 700.000000 700.000000"
        }, [
          _createElementVNode("path", { d: "M179 77.8c-2 2-4 6.7-7.5 17.3-2.6 7.9-42.2 129.3-88.1 269.8C30 528.2.1 621.2.4 622.6c.4 1.3 1.9 2.6 3.7 3.3 2.3.8 75 1.1 257.1 1.1 278.9 0 258.9.5 262-6.1 2.2-4.5 176.8-539 176.8-541 0-.9-.8-2.3-1.8-3.2-1.7-1.6-21.1-1.7-259.1-1.7H181.8l-2.8 2.8zm189.2 159.9c24.9 24.9 26.8 27 26.8 30.3 0 3.3-4.8 8.3-88.7 92.2S217.3 449 214 449c-3.2 0-5.4-2-30.2-26.7-24.9-24.9-26.8-27-26.8-30.3 0-3.3 4.9-8.4 88.8-92.2C329.5 216 334.7 211 338 211c3.2 0 5.5 2 30.2 26.7zm100.7 103.2c25.9 26.3 47.5 48.9 48 50.2.5 1.4.5 3.4-.1 4.9-.5 1.4-12.7 14.3-27.1 28.7-22.8 22.9-26.6 26.3-29.2 26.3-1.6 0-3.7-.6-4.5-1.3-.8-.7-22.8-22.7-48.7-48.8-46-46.3-47.3-47.7-47.3-51.4 0-3.7 1-4.9 25.3-29.5 13.8-14.1 26.5-26.4 28.1-27.2 2.2-1.2 3.6-1.4 5.7-.6 1.6.6 22.2 20.7 49.8 48.7z" })
        ])
      ])
    ], -1))
  ], 2))
}